document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-header]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const menuClose = document.querySelector('[data-menu-close]');

function updateHeader() {
  if (!header) return;
  header.classList.toggle('is-scrolled', window.scrollY > 12);
}

// Both drawers cover the page, so while one is open the rest of the document
// must not be reachable by Tab. These keep focus inside the open panel and hand
// it back to whatever opened it.
const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

let openDrawer = null;
let drawerReturnFocus = null;

function focusableWithin(element) {
  return Array.from(element.querySelectorAll(FOCUSABLE)).filter(
    (node) => node.offsetWidth > 0 || node.offsetHeight > 0 || node === document.activeElement
  );
}

function trapFocus(event) {
  if (event.key !== 'Tab' || !openDrawer) return;

  const items = focusableWithin(openDrawer);
  if (!items.length) return;

  const first = items[0];
  const last = items[items.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

function drawerOpened(drawer) {
  openDrawer = drawer;
  drawerReturnFocus = document.activeElement;
  document.body.style.overflow = 'hidden';
  document.addEventListener('keydown', trapFocus);
  focusableWithin(drawer)[0]?.focus();
}

function drawerClosed() {
  openDrawer = null;
  document.body.style.overflow = '';
  document.removeEventListener('keydown', trapFocus);
  drawerReturnFocus?.focus();
  drawerReturnFocus = null;
}

function openMenu() {
  if (!mobileMenu || !menuToggle) return;
  mobileMenu.hidden = false;
  menuToggle.setAttribute('aria-expanded', 'true');
  drawerOpened(mobileMenu);
}

function closeMenu() {
  if (!mobileMenu || !menuToggle || mobileMenu.hidden) return;
  mobileMenu.hidden = true;
  menuToggle.setAttribute('aria-expanded', 'false');
  drawerClosed();
}

updateHeader();
window.addEventListener('scroll', updateHeader, { passive: true });
menuToggle?.addEventListener('click', openMenu);
menuClose?.addEventListener('click', closeMenu);
mobileMenu?.addEventListener('click', (event) => {
  if (event.target === mobileMenu) closeMenu();
});

document.querySelectorAll('.site-header__shop-menu').forEach((menu) => {
  const summary = menu.querySelector('summary');

  menu.addEventListener('mouseenter', () => {
    if (!window.matchMedia('(min-width: 760px)').matches) return;

    document.querySelectorAll('.site-header__shop-menu[open]').forEach((openMenu) => {
      if (openMenu !== menu) openMenu.removeAttribute('open');
    });

    menu.setAttribute('open', '');
  });

  menu.addEventListener('mouseleave', () => {
    if (!window.matchMedia('(min-width: 760px)').matches) return;
    menu.removeAttribute('open');
  });

  summary?.addEventListener('click', (event) => {
    event.preventDefault();

    document.querySelectorAll('.site-header__shop-menu[open]').forEach((openMenu) => {
      if (openMenu !== menu) openMenu.removeAttribute('open');
    });

    menu.toggleAttribute('open');
  });
});

document.addEventListener('click', (event) => {
  if (event.target.closest('.site-header__shop-menu')) return;
  document.querySelectorAll('.site-header__shop-menu[open]').forEach((menu) => menu.removeAttribute('open'));
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeMenu();
    closeCart();
    document.querySelectorAll('.site-header__shop-menu[open]').forEach((menu) => menu.removeAttribute('open'));
  }
});

// Money formatting, shared by the cart drawer and the product form.
// Both format strings come from the shop's currency settings so they stay the
// single source of truth. The currency-named form is used where Liquid uses
// money_with_currency, so a variant change cannot strip the code off a price
// that was rendered with it.
const themeConfig = window.theme || {};
const moneyFormat = themeConfig.moneyFormat || '${{amount}}';
const moneyWithCurrencyFormat = themeConfig.moneyWithCurrencyFormat || moneyFormat;
const cartStrings = themeConfig.strings || {};
const cartRoutes = themeConfig.routes || {};

function formatMoney(cents, withCurrency = false) {
  const value = Number(cents) || 0;
  const format = withCurrency ? moneyWithCurrencyFormat : moneyFormat;

  const withSeparator = (amount, thousands, decimal, places) => {
    const fixed = (amount / 100).toFixed(places);
    const [whole, fraction] = fixed.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fraction ? grouped + decimal + fraction : grouped;
  };

  return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, placeholder) => {
    switch (placeholder) {
      case 'amount':
        return withSeparator(value, ',', '.', 2);
      case 'amount_no_decimals':
        return withSeparator(value, ',', '.', 0);
      case 'amount_with_comma_separator':
        return withSeparator(value, '.', ',', 2);
      case 'amount_no_decimals_with_comma_separator':
        return withSeparator(value, '.', ',', 0);
      case 'amount_with_apostrophe_separator':
        return withSeparator(value, "'", '.', 2);
      case 'amount_with_space_separator':
        return withSeparator(value, ' ', ',', 2);
      case 'amount_no_decimals_with_space_separator':
        return withSeparator(value, ' ', ',', 0);
      default:
        return withSeparator(value, ',', '.', 2);
    }
  });
}

// Cart drawer functionality
const cartDrawer = document.querySelector('[data-cart-drawer]');
const cartOpen = document.querySelector('[data-cart-open]');
const cartClose = document.querySelector('[data-cart-close]');
const cartContent = document.querySelector('[data-cart-content]');
const cartTotal = document.querySelector('[data-cart-total]');
const cartCount = document.querySelector('[data-cart-count]');

const cartAnnounce = document.querySelector('[data-cart-announce]');

// Clear first, then set on the next frame, or a repeated message is not
// re-announced because the text never changed.
function announceCart(message) {
  if (!cartAnnounce) return;
  cartAnnounce.textContent = '';
  requestAnimationFrame(() => {
    cartAnnounce.textContent = message;
  });
}

function openCart() {
  if (!cartDrawer) return;
  cartDrawer.removeAttribute('hidden');
  drawerOpened(cartDrawer);
  updateCart();
}

function closeCart() {
  if (!cartDrawer || cartDrawer.hasAttribute('hidden')) return;
  cartDrawer.setAttribute('hidden', '');
  drawerClosed();
}

function renderCartMessage(message) {
  if (!cartContent) return;
  cartContent.textContent = '';
  const paragraph = document.createElement('p');
  paragraph.className = 'cart-drawer__empty';
  paragraph.textContent = message;
  cartContent.appendChild(paragraph);
}

// Built with the DOM API rather than innerHTML so product titles and image
// URLs are inserted as text and attribute values, never parsed as markup.
function renderCartItem(item) {
  const row = document.createElement('div');
  row.className = 'cart-item';

  const imageWrap = document.createElement('div');
  imageWrap.className = 'cart-item__image';
  if (item.featured_image && item.featured_image.url) {
    const img = document.createElement('img');
    img.src = item.featured_image.url;
    img.alt = item.featured_image.alt || item.title || '';
    img.loading = 'lazy';
    imageWrap.appendChild(img);
  }
  row.appendChild(imageWrap);

  const info = document.createElement('div');
  info.className = 'cart-item__info';

  const title = document.createElement('h3');
  title.textContent = item.title;
  info.appendChild(title);

  const quantity = document.createElement('p');
  quantity.textContent = `${cartStrings.quantity || 'Qty'}: ${item.quantity}`;
  info.appendChild(quantity);

  const price = document.createElement('p');
  price.textContent = formatMoney(item.final_price);
  info.appendChild(price);

  row.appendChild(info);

  const remove = document.createElement('button');
  remove.type = 'button';
  remove.className = 'cart-item__remove';
  remove.dataset.lineItem = item.key;
  remove.textContent = cartStrings.remove || 'Remove';
  row.appendChild(remove);

  return row;
}

function updateCart() {
  if (!cartContent) return Promise.resolve();

  return fetch(`${cartRoutes.root || '/'}cart.js`, {
    headers: { Accept: 'application/json' },
  })
    .then((res) => {
      if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
      return res.json();
    })
    .then((cart) => {
      if (cartCount) cartCount.textContent = cart.item_count;

      if (cart.items.length === 0) {
        renderCartMessage(cartStrings.emptyCart || 'Your bag is empty');
        if (cartTotal) cartTotal.textContent = formatMoney(0, true);
        return;
      }

      const fragment = document.createDocumentFragment();
      cart.items.forEach((item) => fragment.appendChild(renderCartItem(item)));
      cartContent.textContent = '';
      cartContent.appendChild(fragment);

      if (cartTotal) cartTotal.textContent = formatMoney(cart.items_subtotal_price, true);
    })
    .catch((error) => {
      console.error(error);
      renderCartMessage(cartStrings.error || 'Something went wrong. Please try again.');
    });
}

// Delegated so it survives re-renders and is only bound once.
cartContent?.addEventListener('click', (event) => {
  const button = event.target.closest('[data-line-item]');
  if (!button) return;

  event.preventDefault();
  button.disabled = true;

  fetch(`${cartRoutes.root || '/'}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    // Shopify's `line` is a 1-based index; a line item key goes in `id`.
    body: JSON.stringify({ id: button.dataset.lineItem, quantity: 0 }),
  })
    .then((res) => {
      if (!res.ok) throw new Error(`Cart change failed: ${res.status}`);
      announceCart(cartStrings.itemRemoved || 'Item removed from your bag');
      return updateCart();
    })
    .catch((error) => {
      console.error(error);
      button.disabled = false;
      renderCartMessage(cartStrings.error || 'Something went wrong. Please try again.');
    });
});

if (cartOpen)
  cartOpen.addEventListener('click', (e) => {
    e.preventDefault();
    // The drawer ships with the empty-state markup and was only ever filled
    // after an add, so a returning visitor with items in their bag opened it
    // and read "Your bag is empty". Open first so there is no delay, then
    // refresh.
    openCart();
    updateCart();
  });
if (cartClose) cartClose.addEventListener('click', closeCart);
if (cartDrawer)
  cartDrawer.addEventListener('click', (e) => {
    if (e.target === cartDrawer) closeCart();
  });

const productJson = document.querySelector('[data-product-json]');
const productForm = document.querySelector('.product-form');

if (productJson && productForm) {
  const product = JSON.parse(productJson.textContent);
  const idInput = productForm.querySelector('input[name="id"]');
  const submit = productForm.querySelector('[data-product-submit]');
  const price = document.querySelector('.product-page__price');

  const selectedOptions = () =>
    product.options.map((optionName) => {
      const checked = productForm.querySelector(`input[name="options[${CSS.escape(optionName)}]"]:checked`);
      return checked?.value;
    });

  const updateVariant = () => {
    const options = selectedOptions();
    const variant = product.variants.find((item) => item.options.every((value, index) => value === options[index]));

    if (!variant || !idInput || !submit) return;

    idInput.value = variant.id;
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? 'Add to bag' : 'Sold out';
    if (price) price.textContent = formatMoney(variant.price, true);
  };

  productForm.addEventListener('change', updateVariant);

  // Quantity controls
  const quantityInput = productForm.querySelector('[data-quantity-input]');
  const quantityMinus = productForm.querySelector('[data-quantity-minus]');
  const quantityPlus = productForm.querySelector('[data-quantity-plus]');

  if (quantityInput && quantityMinus && quantityPlus) {
    quantityMinus.addEventListener('click', (e) => {
      e.preventDefault();
      const current = parseInt(quantityInput.value) || 1;
      quantityInput.value = Math.max(1, current - 1);
    });

    quantityPlus.addEventListener('click', (e) => {
      e.preventDefault();
      const current = parseInt(quantityInput.value) || 1;
      quantityInput.value = current + 1;
    });
  }

  // Add to cart over Ajax. Without preventDefault the browser submits the form
  // and navigates, so the notification and drawer never get to run.
  productForm.addEventListener('submit', (event) => {
    event.preventDefault();

    const notification = document.querySelector('[data-notification]');
    const notificationText = document.querySelector('[data-notification-text]');

    const showNotification = (message) => {
      if (!notification || !notificationText) return;
      notification.removeAttribute('hidden');
      notificationText.textContent = message;
    };

    // Remember the pre-submit state so a sold-out variant is not re-enabled.
    const wasDisabled = submit ? submit.disabled : false;
    if (submit) submit.disabled = true;

    fetch(`${cartRoutes.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(productForm),
    })
      .then((res) => {
        if (!res.ok) return res.json().then((body) => Promise.reject(new Error(body.description || res.status)));
        return res.json();
      })
      .then(() => {
        showNotification('Added to bag! Opening your cart...');
        announceCart(cartStrings.itemAdded || 'Added to your bag');
        setTimeout(() => {
          notification?.setAttribute('hidden', '');
          // openCart() refreshes the drawer itself.
          openCart();
        }, 500);
      })
      .catch((error) => {
        console.error(error);
        showNotification(cartStrings.error || 'Something went wrong. Please try again.');
      })
      .finally(() => {
        if (submit) submit.disabled = wasDisabled;
      });
  });
}
